<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">

          <div slot="header">
            <strong>Manual MPS Status Update</strong>
          </div>

          <div id="listloader" v-if="loader">
            <div class="listloader"></div>
          </div>

          <!-- Search Section -->
          <b-row class="align-items-center">

            <b-col sm="2">
              <label>
                <b>MPS / AWB Number</b>
                <span style="color:red">*</span>
              </label>
            </b-col>

            <b-col sm="6">
              <b-form-input
                v-model="awbNo"
                placeholder="Enter MPS / AWB Number" @input="onAwbChange">
              </b-form-input>
            </b-col>
            

            <b-col sm="4">
              <b-button
                variant="info"
                @click="searchData">
                Search
              </b-button>

              <b-button
                variant="danger"
                class="ml-2"
                @click="clearData">
                Clear
              </b-button>

              <router-link
                :to="{ path: '/mpsstatusupdatehistory' }"
                style="text-decoration:none;" target="_blank">

                <span
                  style="font-size:11px; float:right; text-decoration:underline;"
                  class="mt-2">
                  View MPS Status Update History
                  <i class="fa fa-eye"></i>
                </span>

              </router-link>
            </b-col>
          </b-row>

          <b-row class="mt-2" v-if="showCurrentStatus">
              <b-col sm="2">
                  <label>
                      <b>Current Box Status</b>
                  </label>
              </b-col>
              <b-col sm="6">
                  <span class="badge badge-primary"  style="font-size:14px;">
                      {{ currentShipmentStatus }}
                  </span>
              </b-col>
          </b-row>

          <!-- Status Dropdown -->
          <b-row
            class="align-items-center mt-4"
            v-if="showselectdropdown">
            <b-col sm="2">
              <label>
                <b>Update MPS Status To</b>
                <span style="color:red">*</span>
              </label>
            </b-col>
            <b-col sm="6">
              <b-form-select
                v-model="selectedStatus"
                :options="statusOptions">
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'HubInScan'">
              <b-col sm="2">
                  <label>
                      Hub
                      <span style="color:red">*</span>
                  </label>
              </b-col>
              <b-col sm="4">
                  <b-form-select
                      v-model="selectedHub"
                      :options="hubOptions"
                      @change="onHubChange">
                  </b-form-select>
              </b-col>

              <b-col sm="2">
                  <label>
                      Hub User
                      <span style="color:red">*</span>
                  </label>
              </b-col>
              <b-col sm="4">
                  <b-form-select
                      v-model="selectedHubUser"
                      :options="hubUserOptions">
                  </b-form-select>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'ZoneInScan'|| selectedStatus === 'DockInScan'">
              <b-col sm="2">
                  <label>
                      Zone / Dock
                      <span style="color:red">*</span>
                  </label>
              </b-col>
              <b-col sm="6">
                  <b-form-select
                      v-model="selectedZone"
                      :options="zoneOptions">
                  </b-form-select>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'ZoneOutScan'|| selectedStatus === 'DockOutScan'">
              <b-col sm="2">
                  <label>
                      Hub User
                      <span style="color:red">*</span>
                  </label>
              </b-col>
              <b-col sm="6">
                  <b-form-select
                      v-model="selectedHubUser"
                      :options="hubUserOptions">
                  </b-form-select>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'DispatchOutScan' || selectedStatus === 'INTransit'
              ">
              <b-col sm="2">
                  <label>
                      Vehicle
                      <span style="color:red">*</span>
                  </label>
              </b-col>
              <b-col sm="6">
                  <v-select
    v-model="selectedVehicle"
    :options="vehicleOptions"
    label="text"
    :reduce="option => option.value"
    placeholder="Search / Select Vehicle"
    :clearable="true"
    searchable
/>


                    
                    <small
                    v-if="
                        (
                            selectedStatus === 'INTransit'
                            ||
                            selectedStatus === 'DispatchOutScan'
                        )
                        &&
                        loadVehicleNo
                    "
                    class="text-success"
                >
                    Vehicle fetched from load: {{ loadVehicleNo }}
                </small>
                  <!--<b-form-input
                    v-model="selectedVehicle"
                    placeholder="Enter Vehicle Number">
                </b-form-input>-->
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'shortage'">
              <b-col sm="2">
                  <label>
                      Action
                      <span style="color:red">*</span>
                  </label>
              </b-col>

              <b-col sm="6">
                  <b-form-radio-group
                      v-model="shortageAction">
                      <b-form-radio value="MARK">
                          Mark Shortage
                      </b-form-radio>
                      <b-form-radio value="REMOVE">
                          Remove Shortage
                      </b-form-radio>
                  </b-form-radio-group>
              </b-col>
          </b-row>
          <b-row class="mt-3" v-if="selectedStatus === 'Damage' && showselectdropdown">

              <b-col sm="2">
                  <label>
                      Damage Photo
                      <span style="color:red">*</span>
                  </label>
              </b-col>

              <b-col sm="6">
         
                <b-col md="8" class="pl-0">
                    <b-form-file type="file"
                    v-model="damagePhoto"
                    :state="Boolean(image_file)"
                    placeholder="Upload Photo" 
                    @change="selectFile($event)"
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png" plain>
                  </b-form-file>
                </b-col>

              </b-col>

          </b-row>
          <!-- Remarks -->
          <b-row
            class="align-items-center mt-3"
            v-if="showselectdropdown">

            <b-col sm="2">
              <label>
                <b>Remarks</b>
                
              </label>
            </b-col>

            <b-col sm="6">
              <b-form-textarea
                v-model="remarks"
                rows="3"
                placeholder="Enter reason for manual update">
              </b-form-textarea>
            </b-col>

          </b-row>

          <!-- Update Button -->
          <b-row
            class="mt-3"
            v-if="showselectdropdown">

            <b-col sm="8">
            <div class="alert alert-warning mb-0 p-2" style="font-size:13px;" v-if="selectedStatus && statusNote">
                  <i class="fa fa-info-circle"></i>
                  <b>Allowed Current Status:</b>
                  {{ statusNote }}
              </div>
            </b-col>

            <b-col sm="4">
              <b-button
                variant="success"
                @click="updateMpsStatus">

                Update Status
              </b-button>
            </b-col>

          </b-row>

          <!-- Table -->
          <b-row class="mt-4">

            <b-col sm="12">

              <b-table
                show-empty
                responsive
                :busy="isBusy"
                :items="items"
                :fields="fields">

                <div
                  slot="table-busy"
                  class="text-center text-danger my-2">

                  <b-spinner></b-spinner>
                  <strong>Loading...</strong>

                </div>

                <!-- Select All -->
                <template
                  slot="HEAD_select"
                  slot-scope="data">

                  <div v-if="items && items.length > 0">
                    Select All
                    <br>

                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @change="toggleSelectAll">
                  </div>

                </template>

                <!-- Row Checkbox -->
                <template
                  slot="select"
                  slot-scope="row">

                  <input
                    type="checkbox"
                    :checked="selectedMpsIds.includes(row.item.mpsid)"
                    @change="toggleRow(row.item.mpsid)">
                </template>
                <template slot="shippingid" slot-scope="row">
                      <span>{{row.item.shippingid}}
                      <br>
                      ({{row.item.parentawb}})</span>
                      <br>
                      <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px; cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                      &nbsp;
                      <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">SB</span>
                       <span  v-if="row.item.is_normalbox_scanned == 'Yes' && ['INTransit', 'PickDone'].includes(row.item.shipmentstatus)" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">HubInScan</span>
                  </template>
                <template
                  slot="hubtitle"
                  slot-scope="row">

                  {{ row.item.hub_title }}

                  <br>

                  <span style="color:blue" v-if="row.item.hub_id">
                    HubID-{{ row.item.hub_id }}
                  </span>

                </template>

                <template
                  slot="mps_value"
                  slot-scope="row">

                  <i class="fa fa-rupee"></i>
                  {{ row.item.mpsvalue }}

                </template>

                <template
                  slot="physical_weight"
                  slot-scope="row">

                  {{ row.item.physicalweight }} KG

                </template>

                <template
                  slot="lhb"
                  slot-scope="row">

                  {{ Number(row.item.length) || 0 }}
                  *
                  {{ Number(row.item.breadth) || 0 }}
                  *
                  {{ Number(row.item.height) || 0 }}

                </template>

              </b-table>

            </b-col>

          </b-row>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import vSelect from 'vue-select';

export default {
components: {
        vSelect
    },
  data() {

    return {
      awbNo: "",
      searchedAwbNo: "",
      items: [],
      loader: false,
      selectAll: false,
      selectedMpsIds: [],
      selectedStatus: null,
      selectedHub: null,
      selectedHubUser: null,
      selectedZone: null,
      selectedVehicle: null,
      shortageAction: null,
      damagePhoto: null,
      currentShipmentStatus: '',
      showCurrentStatus: false,         
      remarks: "",
      showselectdropdown: false,
      uploadLoader: false,
      fields: [
        {
          key: "select",
          label: "Select"
        },
        {
          key: "shippingid",
          label: "MPS No"
        },
        {
          key: "mps_value",
          label: "MPS Value"
        },
        {
          key: "lhb",
          label: "LBH"
        },
        {
          key: "physical_weight",
          label: "Physical Weight"
        },
        {
          key: "shipmentstatus",
          label: "Shipment Status"
        },
        {
          key: "deliverystatus",
          label: "Delivery Status"
        },
        {
          key: "hubtitle",
          label: "Hub Name"
        },
        {
          key: "zone_title",
          label: "Zone Name"
        },
        {
          key: "vehicle_no",
          label: "Vehicle Number"
        },
         {key:"lastmodifiedby", label:'Last Modified By',
                 tdClass: 'text-nowrap'},
            {
                key: "lastmodifiedon",
                label: "Last Modified On",
                formatter: value => {
                    if (!value) return "NA";

                    const date = new Date(value);

                    return date.toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true
                    });
                },
                tdClass: "text-nowrap"
            }
      ],
      statusOptions: [
        {
          value: null,
          text: "-- Select Status --"
        },
        {
          value: "HubInScan",
          text: "HubInScan"
        },
        {
          value: "ZoneInScan",
          text: "ZoneInScan"
        },
        {
          value: "DockInScan",
          text: "DockInScan"
        },
        {
          value: "ZoneOutScan",
          text: "ZoneOutScan"
        },
        {
          value: "DockOutScan",
          text: "DockOutScan"
        },
        {
          value: "DispatchOutScan",
          text: "DispatchOutScan"
        },
        {
            value: "INTransit",
            text: "InTransit"
        },
        {
          value: "shortage",
          text: "shortage"
        },
        {
          value: "Damage",
          text: "Damage"
        }        
      ],
      hubOptions: [
          {
              value: null,
              text: "-- Select Hub --"
          }
      ],
      hubUserOptions: [
          {
              value: null,
              text: "-- Select Hub User --"
          }
      ],
      zoneOptions: [
          { value: null, text: "-- Select Zone --" }
      ],

      vehicleOptions: [
          { value: null, text: "-- Select Vehicle --" }
      ],
      selected_imagefile:'',
      selectedfile_type : '',
      uploadedphoto :'',
      loadVehicleNo: null,
      
    };
  },
  created() {
    this.loadHubList();
  },
  methods: {

  async loadVehicleForSelectedMps() {

    const selectedRows = this.items.filter(
        item => this.selectedMpsIds.includes(item.mpsid)
    );

    if (!selectedRows.length) {

        this.selectedVehicle = null;
        this.loadVehicleNo = null;

        return;
    }

    const vehicles = [
        ...new Set(
            selectedRows
                .map(item => item.vehicle_no)
                .filter(vehicle => vehicle)
        )
    ];

    /*
     * ==========================================
     * DispatchOutScan
     * ==========================================
     *
     * Always load complete vehicle list.
     * If vehicle already exists against load,
     * pre-select it after API response.
     */
        if (this.selectedStatus === "DispatchOutScan") {

            await this.loadVehicleList();

            /*
            * Get AWBs of selected MPS
            */
            const selectedAwbs = [
                ...new Set(
                    selectedRows
                        .map(item => item.parentawb)
                        .filter(awb => awb)
                )
            ];

            /*
            * Find vehicles from ALL MPS belonging
            * to the same AWB where shipmentstatus
            * is already DispatchOutScan.
            */
            const dispatchVehicles = [
                ...new Set(
                    this.items
                        .filter(item =>
                            selectedAwbs.includes(item.parentawb)
                            &&
                            String(item.shipmentstatus || '')
                                .trim()
                                .toLowerCase() === 'dispatchoutscan'
                            &&
                            item.vehicle_no
                        )
                        .map(item =>
                            String(item.vehicle_no).trim()
                        )
                        .filter(vehicle => vehicle)
                )
            ];

            console.log(
                "Selected rows:",
                selectedRows
            );

            console.log(
                "Selected AWBs:",
                selectedAwbs
            );

            console.log(
                "DispatchOutScan vehicles from same AWB:",
                dispatchVehicles
            );

            /*
            * Exactly one vehicle found
            */
            if (dispatchVehicles.length === 1) {

                const vehicleNo =
                    dispatchVehicles[0];

                this.loadVehicleNo = vehicleNo;

                const vehicleExists =
                    this.vehicleOptions.some(
                        option =>
                            String(option.value || '')
                                .trim()
                                .toLowerCase()
                            ===
                            vehicleNo
                                .trim()
                                .toLowerCase()
                    );

                if (vehicleExists) {

                    this.selectedVehicle = vehicleNo;

                } else {

                    this.selectedVehicle = null;
                }

            } else if (dispatchVehicles.length > 1) {

                /*
                * Same AWB has multiple vehicles already
                * associated with DispatchOutScan.
                */
                this.$fire({
                    text:
                        "Multiple vehicles found for the selected AWB. Please select a vehicle.",
                    type: "warning"
                });

                this.loadVehicleNo = null;
                this.selectedVehicle = null;

            } else {

                /*
                * No DispatchOutScan vehicle found.
                *
                * Show complete vehicle list and let
                * user select manually.
                */
                this.loadVehicleNo = null;
                this.selectedVehicle = null;
            }
            return;
        }
/*
 * ==========================================
 * INTransit
 * ==========================================
 */
if (this.selectedStatus === "INTransit") {

    /*
     * Get AWBs of selected MPS
     */
    const selectedAwbs = [
        ...new Set(
            selectedRows
                .map(item => item.parentawb)
                .filter(awb => awb)
        )
    ];

    /*
     * =====================================================
     * First priority:
     *
     * Vehicle directly available on selected MPS
     * =====================================================
     */
    const selectedVehicles = [
        ...new Set(
            selectedRows
                .map(item =>
                    String(item.vehicle_no || '').trim()
                )
                .filter(vehicle => vehicle)
        )
    ];


    /*
     * =====================================================
     * Second priority:
     *
     * If selected MPS has no vehicle,
     * find vehicle from another MPS of same AWB
     *
     * Current status must be INTransit.
     * =====================================================
     */
    const inTransitVehicles = [
        ...new Set(
            this.items
                .filter(item =>
                    selectedAwbs.includes(item.parentawb)
                    &&
                    String(item.shipmentstatus || '')
                        .trim()
                        .toLowerCase() === 'intransit'
                    &&
                    item.vehicle_no
                )
                .map(item =>
                    String(item.vehicle_no).trim()
                )
                .filter(vehicle => vehicle)
        )
    ];


    console.log(
        "Selected rows:",
        selectedRows
    );

    console.log(
        "Selected AWBs:",
        selectedAwbs
    );

    console.log(
        "Selected vehicles:",
        selectedVehicles
    );

    console.log(
        "INTransit vehicles from same AWB:",
        inTransitVehicles
    );


    /*
     * =====================================================
     * CASE 1
     *
     * Selected MPS itself has exactly one vehicle.
     * =====================================================
     */
    if (selectedVehicles.length === 1) {

        const vehicleNo =
            selectedVehicles[0];

        this.loadVehicleNo =
            vehicleNo;

        this.vehicleOptions = [
            {
                value: null,
                text: "-- Select Vehicle --"
            },
            {
                value: vehicleNo,
                text: vehicleNo
            }
        ];

        this.selectedVehicle =
            vehicleNo;

        return;
    }


    /*
     * =====================================================
     * CASE 2
     *
     * Selected MPS has no vehicle,
     * but another MPS of same AWB is already INTransit
     * with a vehicle.
     *
     * Example:
     *
     * MPS31 → INTransit → MA06MA0606
     * MPS32 → HubInScan → empty
     *
     * Select MPS32
     * ↓
     * Find MPS31
     * ↓
     * Preselect MA06MA0606
     * =====================================================
     */
    if (inTransitVehicles.length === 1) {

        const vehicleNo =
            inTransitVehicles[0];

        this.loadVehicleNo =
            vehicleNo;

        this.vehicleOptions = [
            {
                value: null,
                text: "-- Select Vehicle --"
            },
            {
                value: vehicleNo,
                text: vehicleNo
            }
        ];

        this.selectedVehicle =
            vehicleNo;

        return;
    }


    /*
     * =====================================================
     * CASE 3
     *
     * Multiple vehicles found
     * =====================================================
     */
    if (inTransitVehicles.length > 1) {

        this.$fire({
            text:
                "Multiple vehicles found for the selected AWB. Please select a vehicle.",
            type: "warning"
        });

        this.loadVehicleNo = null;

        await this.loadVehicleList();

        this.selectedVehicle = null;

        return;
    }


    /*
     * =====================================================
     * CASE 4
     *
     * No vehicle found anywhere in same AWB.
     *
     * Load complete vehicle list.
     * User must select manually.
     * =====================================================
     */
    this.loadVehicleNo = null;

    await this.loadVehicleList();

    this.selectedVehicle = null;
}
    
},
loadVehicleList() {
    return this.$http.post(
        `${CONSTANTS.MIGRATION_API_URL}/getVehicleListNew`
    )
    .then(result => {

        if (
            result.body &&
            result.body.returnmsg === "successful"
        ) {

            const vehicles =
                result.body.returnvalue || [];

            this.vehicleOptions = [
                {
                    value: null,
                    text: "-- Select Vehicle --"
                },

                ...vehicles.map(vehicle => ({
                    value: vehicle.vehicle_name,
                    text: vehicle.vehicle_name
                }))
            ];

            return this.vehicleOptions;

        } else {

            this.vehicleOptions = [
                {
                    value: null,
                    text: "-- Select Vehicle --"
                }
            ];

            return this.vehicleOptions;
        }

    })
    .catch(error => {

        console.log(
            "Vehicle list error:",
            error
        );

        this.vehicleOptions = [
            {
                value: null,
                text: "-- Select Vehicle --"
            }
        ];

        return this.vehicleOptions;
    });
},
toggleRow(mpsid) {
    const index = this.selectedMpsIds.indexOf(mpsid);
    if (index > -1) {
        this.selectedMpsIds.splice(index, 1);
    } else {
        this.selectedMpsIds.push(mpsid);
    }
    this.showselectdropdown =this.selectedMpsIds.length > 0;
    this.selectAll =this.items.length > 0 &&
        this.selectedMpsIds.length === this.items.length;
    /*
     * If current selected status is InTransit,
     * fetch vehicle against selected load/MPS.
     */
    if (
        (this.selectedStatus === "INTransit" ||
        this.selectedStatus === "DispatchOutScan")
        && 
        this.selectedMpsIds.length > 0
    ) {
        this.loadVehicleForSelectedMps();
    }

    /*
     * Existing ZoneOut/DockOut logic
     */
    if (
        (
            this.selectedStatus === "ZoneOutScan"
            ||
            this.selectedStatus === "DockOutScan"
        )
        &&
        this.selectedMpsIds.length > 0
    ) {
        const hubId = this.getSelectedHubId();
        if (hubId) {
            this.selectedHub = hubId;
            this.loadHubUsers();
        }
    }
},
   
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedMpsIds =this.items.map(
            item => item.mpsid
          );
      }else{
        this.selectedMpsIds = [];
      }
      this.showselectdropdown =this.selectedMpsIds.length > 0;
      /*
     * InTransit vehicle handling
     */
    if (
        (this.selectedStatus === "INTransit" ||
        this.selectedStatus === "DispatchOutScan")
        &&
        this.selectedMpsIds.length > 0
    ) {

        this.loadVehicleForSelectedMps();

    } else {

        this.selectedVehicle = null;
        this.loadVehicleNo = null;
    }
      if ((this.selectedStatus === "ZoneOutScan" || this.selectedStatus === "DockOutScan") && this.selectedMpsIds.length > 0)
      {
        const hubId = this.getSelectedHubId();
        if (hubId) {
            this.selectedHub = hubId;
            this.loadHubUsers();
        }
      }
    },
    searchData() {
      this.loader = true;
      this.awbNo =this.awbNo? this.awbNo.trim(): "";
      if (!this.awbNo) {
        this.loader = false;
        this.$fire({
          text:
            "Please Enter Valid Parent AWB / MPS No.",
          type: "warning"
        });
        return;
      }
      this.$http.post(
        `${CONSTANTS.MIGRATION_API_URL}/getMpasOrAwbdetails`,
        {
          keyword: this.awbNo
        }
      ).then(result => {
        this.loader = false;
        if (
          result.body.returnmsg === "successful"
        ) {
          this.items =result.body.returnvalue;
          this.searchedAwbNo = this.awbNo;
            if (this.items.length > 0) {
                const statuses = [
                    ...new Set(
                        this.items.map(
                            x => x.shipmentstatus
                        )
                    )
                ];
                this.currentShipmentStatus =statuses.join(", ");
                this.showCurrentStatus = true;
            } else {
                this.currentShipmentStatus = '';
                this.showCurrentStatus = false;
            }
        } else {
          this.items = [];
          this.$fire({
            text:
              result.body.returnvalue,
            type: "warning"
          });
        }
      })
      .catch(() => {
        this.loader = false;
      });

    },
    updateMpsStatus() {
     // var userdata = localStorage.getItem("userData");
      //var userInfo = JSON.parse(userdata);
      let userInfo = {};

      try {
          const userdata = localStorage.getItem("userData");
          if (!userdata) {
              this.$fire({
                  text: "User session not found. Please login again.",
                  type: "warning"
              });
              return;
          }
          userInfo = JSON.parse(userdata);

      } catch (error) {
          console.error("Invalid userData:", error);
          this.$fire({
              text: "Invalid user session. Please login again.",
              type: "error"
          });
          return;
      }

    console.log(userInfo);
      if (this.selectedMpsIds.length === 0) {
          this.$fire({
              text: "Please select MPS.",
              type: "warning"
          });
          return;
      }

      if (!this.selectedStatus) {
          this.$fire({
              text: "Please select status.",
              type: "warning"
          });
          return;
      }

     
      if (this.selectedStatus === "HubInScan") {
          if (!this.selectedHub) {
              this.$fire({
                  text: "Please select Hub.",
                  type: "warning"
              });
              return;
          }
          if (!this.selectedHubUser) {
              this.$fire({
                  text: "Please select Hub User.",
                  type: "warning"
              });
              return;
          }
      }
      if (this.selectedStatus === 'ZoneInScan' || this.selectedStatus === 'DockInScan' ) {
          if (!this.selectedZone) {
             this.$fire({
                text: 'Please select Zone',
                type: 'warning'
            });
            return;
          }
      }
      if (this.selectedStatus === 'ZoneOutScan' || this.selectedStatus === 'DockOutScan') {
          if (!this.selectedHubUser) {             
              this.$fire({
                  text: 'Please select Hub User',
                  type: 'warning'
              });
              return;
          }
      }
    if (this.selectedStatus === 'DispatchOutScan') {
        const hubId = this.getSelectedHubId();
        if (!hubId) {
            this.$fire({
                text: 'Unable to determine Hub for selected MPS.',
                type: 'warning'
            });

            return;
        }
    }

     if (
    this.selectedStatus === 'DispatchOutScan'
    ||
    this.selectedStatus === 'INTransit') {

    if (
        !this.selectedVehicle
        ||
        !String(this.selectedVehicle).trim()
    ) {

        this.$fire({
            text: 'Please select Vehicle Number.',
            type: 'warning'
        });

        return;
    }
}

    /*
    * INTransit current status validation
    *
    * Allowed current status:
    * 1. HubInScan
    * 2. InTransit inward scanned
    */
    if (this.selectedStatus === 'INTransit') {

        const selectedRows = this.items.filter(
            item => this.selectedMpsIds.includes(item.mpsid)
        );

        const invalidMps = selectedRows.filter(item => {

            const shipmentStatus =
                String(item.shipmentstatus || '')
                    .trim()
                    .toLowerCase();

            /*
            * Scenario 1 & 3:
            *
            * HubInScan
            * is_normalbox_scanned can be Yes OR No
            *
            * Both are allowed.
            */
            if (shipmentStatus === 'hubinscan') {
                return false;
            }

            /*
            * Scenario 2:
            *
            * INTransit + scanned Yes
            *
            * Allowed.
            */
            if (
                shipmentStatus === 'intransit'
                &&
                String(item.is_normalbox_scanned || '')
                    .trim()
                    .toLowerCase() === 'yes'
            ) {
                return false;
            }

            /*
            * Everything else is invalid.
            */
            return true;
        });

        if (invalidMps.length > 0) {

            this.$fire({
                text:
                    'INTransit can be updated only when current status is HubInScan or INTransit with is_normalbox_scanned as Yes.',
                type: 'warning'
            });

            return;
        }


        /*
        * Vehicle is required for HubInScan.
        *
        * Vehicle is NOT required when:
        * INTransit + is_normalbox_scanned = Yes
        */
        const requiresVehicle = selectedRows.some(item => {

            const shipmentStatus =
                String(item.shipmentstatus || '')
                    .trim()
                    .toLowerCase();

            return shipmentStatus === 'hubinscan';
        });

        if (
            requiresVehicle
            &&
            (
                !this.selectedVehicle
                ||
                !String(this.selectedVehicle).trim()
            )
        ) {

            this.$fire({
                text: 'Please select Vehicle Number.',
                type: 'warning'
            });

            return;
        }
    }

     
      if (this.selectedStatus === 'Damage') {
          if (!this.damagePhoto) {
            this.$fire({
                  text: 'Please upload damage image',
                  type: 'warning'
              });
              return;              
          }
      }
      if (this.selectedStatus === 'shortage') {
          if (!this.shortageAction) {
              this.$fire({
                  text: "Please select shortage action.",
                  type: "warning"
              });
              return;
          }
      }
      this.$bvModal.msgBoxConfirm(
          `Are you sure you want to update ${this.selectedMpsIds.length} selected MPS to "${this.selectedStatus}" status ?`,
          {
              title: "Confirm Status Update",
              size: "md",
              buttonSize: "sm",
              okVariant: "success",
              okTitle: "Yes",
              cancelTitle: "No",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true
          }
      )
      .then(value => {

          if (!value) {
              return;
          }

          const selectedRecords = this.items
              .filter(item =>
                  this.selectedMpsIds.includes(item.mpsid)
              )
              .map(item => ({
                  mpsid: item.mpsid,
                  parentawb: item.parentawb,
                  hub_id: item.hub_id
              }));

            let hubId = this.selectedHub;

            if (this.selectedStatus === 'DispatchOutScan') {
                hubId = this.getSelectedHubId();
            }
        const obj = {
            records: selectedRecords,
            status: this.selectedStatus,
            remarks: this.remarks,
            hubid: hubId,
            hubuserid: this.selectedHubUser,
            zoneid: this.selectedZone,
            vehicleno: this.selectedVehicle &&
            typeof this.selectedVehicle === "object"
                ? String(this.selectedVehicle.value || "").trim()
                : this.selectedVehicle
                    ? String(this.selectedVehicle).trim()
                    : "",
            shortageaction: this.shortageAction,
            lastmodifiedbyid: userInfo && userInfo.sysusermasterid ? userInfo.sysusermasterid :"",
            lastmodifiedby: userInfo && userInfo.sysemailid ? userInfo.sysemailid.trim() : "",
            defective_imageurl:this.uploadedphoto
        };
console.log('objrrrrrrrrr',obj)

          this.loader = true;

          this.$http.post(
              `${CONSTANTS.MIGRATION_API_URL}/manualMpsStatusUpdate`,
              obj
          )
          .then(result => {

              this.loader = false;

              if (
                  result.body.returnmsg === "successful"
              ) {

                  this.$fire({
                      text: result.body.returnvalue,
                      type: "success"
                  });
                  this.selectedHub = null;
                  this.selectedHubUser = null;
                  this.selectedZone = null;
                  this.selectedVehicle = null;
                  this.shortageAction = null;
                  this.damagePhoto = null;
                  this.loadVehicleNo = null;
                  this.selectedMpsIds = [];
                  this.selectAll = false;
                  this.selectedStatus = null;
                  this.remarks = "";
                  this.showselectdropdown = false;
                  this.searchData();
              } else {
                  this.$fire({
                      text: result.body.returnvalue,
                      type: "warning"
                  });

              }

          })
          .catch(() => {
              this.loader = false;
              this.$fire({
                  text: "Something went wrong.",
                  type: "error"
              });

          });

      });

    },   
    clearData() {
      this.awbNo = "";
      this.items = [];
      this.selectedMpsIds = [];
      this.selectAll = false;
      this.selectedStatus = null;
      this.remarks = "";
      this.selectedHub = null;
      this.selectedHubUser = null;
      this.selectedZone = null;
      this.selectedVehicle = null;
      this.shortageAction = null;
      this.damagePhoto = null;
      this.loadVehicleNo = null;
      this.showselectdropdown = false;
      this.currentShipmentStatus = '';
      this.showCurrentStatus = false;
    },
    loadHubList() {
        this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/getHubList`
        ).then(result => {
            if (
                result.body.returnmsg ===
                "successful"
            ) {
                this.hubOptions = [
                    {
                        value: null,
                        text: "-- Select Hub --"
                    },
                    ...result.body.returnvalue
                ];
            }
        });
    },
    loadHubUsers() {
      if (!this.selectedHub) {
          this.hubUserOptions = [
              {
                  value: null,
                  text: "-- Select Hub User --"
              }
          ];
          return;
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubUsers`,
          {
              hubid: this.selectedHub
          }
      ).then(result => {
          if (result.body.returnmsg ==="successful"){
              this.hubUserOptions = [
                  {
                      value: null,
                      text: "-- Select Hub User --"
                  },
                  ...result.body.returnvalue
              ];
          }
      });
    },
    onHubChange() {
      this.selectedHubUser = null;
      this.loadHubUsers();
    },
    onAwbChange() {
      if (this.awbNo === this.searchedAwbNo) {
        return;
      }
      this.items = [];
      this.selectedMpsIds = [];
      this.selectAll = false;
      this.selectedStatus = null;
      this.showselectdropdown = false;
      this.remarks = "";
      this.selectedHub = null;
      this.selectedHubUser = null;
      this.selectedZone = null;
      this.selectedVehicle = null;
      this.loadVehicleNo = null;
      this.shortageAction = null;
      this.damagePhoto = null;
      this.currentShipmentStatus = '';
      this.showCurrentStatus = false;
    },
    loadZoneList(hubid) {
      if (!hubid) {
          this.zoneOptions = [
              {
                  value: null,
                  text: "-- Select Zone --"
              }
          ];
          return;
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getZoneListByHub`,
          {
              hub_id: hubid,
              selectedStatus:this.selectedStatus
          }
      )
      .then(result => {
          if (result.body.returnmsg ==="successful") {
              this.zoneOptions = [
                  {
                      value: null,
                      text: "-- Select Zone --"
                  },
                  ...result.body.returnvalue
              ];

          }

      });
    },
    getSelectedHubId() {
        const selectedRows =this.items.filter(item => this.selectedMpsIds.includes(
                                  item.mpsid));
        if (!selectedRows.length) {
            return null;
        }
        const hubs = [
            ...new Set(
                selectedRows.map(
                    x => x.hub_id
                )
            )
        ];
        if (hubs.length > 1) {
            this.$fire({
                text:
                    "Selected MPS belong to multiple hubs.",
                type: "warning"
            });
            return null;
        }
        return hubs[0];
    },

    selectFile(event) {
        const file = event.target.files[0];

        if (!file) return;

        const allowedTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png"
        ];

        if (!allowedTypes.includes(file.type)) {
            this.$fire({
                text: "Only JPG, JPEG and PNG files are allowed.",
                type: "error",
                timer: 3000
            });

            this.selected_imagefile = null;
            this.damagePhoto = null;
            event.target.value = "";
            return;
        }

        this.selected_imagefile = file;
        this.selectedfile_type = file.type;

        this.uploaddamagephoto(file);
    },

    uploaddamagephoto : function () {
    this.uploadLoader = true;
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);

    let data = new FormData();
    data.append('file', this.selected_imagefile)
    this.progress=0;
    let config = {
        header : {
            'Content-Type' : 'multipart/form-data'
        }
    }

    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadFileToS3`,data).then(response => {
               this.uploadLoader = false;

        if (response.data.result=="success") {
            this.$fire({
                text:"File Uploaded.Please Submit",
                type: "success",
                timer: 300000
            })
            this.uploadedphoto=response.data.file_url;
        } else {
            this.$fire({
                text:"File Not Uploaded",
                type: "error",
                timer: 300000
            })
        }
    })
    .catch(e => {
     this.uploadLoader = false;
             console.error("Upload error:", e);

        this.$fire({
            text: "Something went wrong while uploading image.",
            type: "error"
        });
    })
    },

  },
  watch: {
    selectedStatus(newVal) {

    this.selectedHub = null;
    this.selectedHubUser = null;
    this.selectedZone = null;
    this.selectedVehicle = null;
    this.shortageAction = null;
    this.damagePhoto = null;
    this.loadVehicleNo = null;

    /*
     * Zone In / Dock In
     */
    if (
        newVal === "ZoneInScan"
        ||
        newVal === "DockInScan"
    ) {

        if (
            this.items
            &&
            this.items.length > 0
        ) {

            this.loadZoneList(
                this.items[0].hub_id
            );
        }
    }

    /*
     * Zone Out / Dock Out
     */
    if (
        newVal === "ZoneOutScan"
        ||
        newVal === "DockOutScan"
    ) {
        const hubId = this.getSelectedHubId();
        if (hubId) {
            this.selectedHub = hubId;
            this.loadHubUsers();
        }
    }

    /*
     * Hub In
     */
    if (newVal === "HubInScan") {
        const hubId = this.getSelectedHubId();
        if (hubId) {
            this.selectedHub = hubId;
            this.loadHubUsers();
        }
    }

    /*
     * INTransit
     */
    if (newVal === "INTransit" ||
    newVal === "DispatchOutScan") {
        if (this.selectedMpsIds.length > 0) {
            this.loadVehicleForSelectedMps();
        } else {
            this.loadVehicleList();
        }
    }

},
  },
  computed: {
    statusNote() {
        switch (this.selectedStatus) {
            case "HubInScan":
                return "Current Box Status should be: NDR /INTransit / PickDone / HubInScanPending";

            case "ZoneInScan":
            case "DockInScan":
                return "Current Box Status should be: HubInScan / ZoneOutScan /DockOutScan/ DispatchOutScan";

            case "ZoneOutScan":
            case "DockOutScan":
                return "Current Box Status should be: ZoneInScan / DockInScan/DispatchOutScan";

            case "DispatchOutScan":
                return "Current Box Status should be: HubInScan / ZoneInScan / ZoneOutScan/DockInScan/DockOutScan";

            case "INTransit":
                return "Current Box Status should be: HubInScan / InTransit inward scanned";

            case "shortage":
                return "Shortage can be marked or removed on eligible MPS.";

            case "Damage":
                return "Damage photo upload is mandatory.";
                

            default:
                return "";
        }
    }
  }
};
</script>
